import { jsx as _jsx } from "react/jsx-runtime";
import * as Styled from './dimmer.styles';
export const DimmerPrimitive = ({ className, onClick, title, ...props }) => (_jsx(Styled.Dimmer, { className: className, "data-xds": "Dimmer", onClick: onClick, title: title, ...props }));
DimmerPrimitive.displayName = 'Dimmer (Primitive)';
//# sourceMappingURL=dimmer.primitive.js.map